import { Box, Button, Container, Link, Typography } from '@mui/material';
import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

export class SeamHeader extends React.Component {
    public render(): React.ReactNode {
        return (
            <Container maxWidth={false} style={{ background: '#f5f5f5' }}>
                <Typography variant='h4'>The SEAM Team</Typography>
                <Box display='flex' className='mt-1'>
                    <Link to='/seam/dashboard' component={RouterLink} underline='hover'>
                        <Box mr='2rem'>Assigned to me</Box>
                    </Link>
                    <Link to='/seam/kanban' component={RouterLink} underline='hover'>
                        <Box mr='2rem'>Team Kanban</Box>
                    </Link>
                    <Link
                        to='/seam/team'
                        component={RouterLink}
                        color='textSecondary'
                        onClick={(evt) => evt.preventDefault()}
                        underline='hover'
                    >
                        <Box mr='2rem'>Assigned to Team</Box>
                    </Link>
                    <Link to='/seam/labeling' component={RouterLink} underline='hover'>
                        <Box mr='2rem'>Tagging Quality</Box>
                    </Link>
                    <Link to='/seam/metrics' component={RouterLink} underline='hover'>
                        <Box mr='2rem'>Topline Metrics</Box>
                    </Link>
                    <Link to='/seam/tagging' component={RouterLink} underline='hover'>
                        <Box component='span' style={{ cursor: 'pointer', marginRight: '2rem' }} mr='2rem'>
                            ML Tagging
                        </Box>
                    </Link>
                    <Box flexGrow={1} />
                    <Button
                        type='button'
                        variant='contained'
                        color='primary'
                        size='small'
                        className='mb-1'
                        component={RouterLink}
                        to='/cris/request/new?from=seam'
                    >
                        Create Request
                    </Button>
                </Box>
            </Container>
        );
    }
}
